import React, { useState, useEffect } from "react";
import {
  Form,
  Card,
  Button,
  Row,
  Col,
  Container,
  Modal,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useGlobalState } from "../../../services/hostelConst";
import { useSelector } from "react-redux"; // Add this import
import {
  addRoomType,
  updateRoomType,
} from "../../../services/OrganisationServices/hostelRoomServices";
import {
  callToast,
  prepareSiteList,
  showErrorMessages,
} from "../../../../src/services/utilityFunctions.js";

const PRICE_FOR_UNITS = [
  { value: "DAY", label: "Day" },
  { value: "WEEK", label: "Week" },
  { value: "MONTH", label: "Month" },
];

const initialFormState = {
  bed: "",
  description: "",
  isAC: "N",
  name: "",
  price: "",
  priceFor: "1",
  priceForUnit: "DAY",
  hostelId: "",
  id: null,
};

// Fix: Properly destructure props to get data if it's passed
const AddHostelRoomTypeForm = (props) => {
  // Properly destructure navigate and refresh from props
  const { navigate, refresh, data } = props;
  
  const { openModal, closeModal, modalState } = useGlobalState();
  const masterData = modalState.data;
  
  // Get hostelId from URL param or modalState
  const { id } = useParams();
  const reduxState = useSelector((state) => state.modal); // Access Redux store
  
  // Fix: Get hostelId from multiple possible sources
  const hostelId = data?.hostelId || modalState.hostelId || reduxState?.hostelId || id;

  console.log("hostelId here in the add room type form", hostelId);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "success",
  });
  
  const [formData, setFormData] = useState({
    ...initialFormState,
    hostelId,
    ...(masterData && {
      bed: masterData.BEDS || masterData.BED || "",
      description: masterData.DESCRIPTION || "",
      isAC: masterData.AC || masterData.IS_AC || "N",
      name: masterData.NAME || "",
      price: masterData.PRICE || "",
      priceFor: masterData.PRICE_FOR || "1",
      priceForUnit: masterData.PRICE_FOR_UNIT || "DAY",
      id: masterData._ID || null,
    }),
  });

  useEffect(() => {
    if (masterData) {
      const updatedFormData = {
        bed: masterData.BED || masterData.BEDS || "",
        description: masterData.DESCRIPTION || "",
        isAC: masterData.AC || masterData.IS_AC || "N",
        name: masterData.NAME || "",
        price: masterData.PRICE || "",
        priceFor: masterData.PRICE_FOR || "1",
        priceForUnit: masterData.PRICE_FOR_UNIT || "DAY",
        hostelId,
        id: masterData._ID,
      };
      console.log("Setting form data:", updatedFormData);
      setFormData(updatedFormData);
    }
  }, [masterData, hostelId]);
  
  // Make sure hostelId is always set in formData when it changes
  useEffect(() => {
    if (hostelId && hostelId !== formData.hostelId) {
      setFormData(prev => ({
        ...prev,
        hostelId
      }));
    }
  }, [hostelId]);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) {
      newErrors.name = "Room type name is required";
    }
    if (!formData.bed || formData.bed < 1) {
      newErrors.bed = "Number of beds must be at least 1";
    }
    if (!formData.price || formData.price < 0) {
      newErrors.price = "Price must be a positive number";
    }
    if (!formData.description?.trim()) {
      newErrors.description = "Description is required";
    }
    if (!formData.priceFor || formData.priceFor < 1) {
      newErrors.priceFor = "Price duration must be at least 1";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    
    // Extra validation to ensure hostelId is present
    if (!formData.hostelId) {
      setErrors(prev => ({
        ...prev,
        form: "Hostel ID is missing. Please try again or contact support."
      }));
      console.error("Missing hostelId in form submission", { formData, modalState, id });
      return;
    }

    setIsLoading(true);

    const response = masterData
      ? await updateRoomType(formData)
      : await addRoomType(formData);

    if (response.status === "success") {
      callToast(
        "success",
        "Success",
        `Room type ${masterData ? "updated" : "added"} successfully!`
      );

      if (!masterData) {
        setFormData({
          bed: "",
          description: "",
          isAC: "N",
          name: "",
          price: "",
          priceFor: "1",
          priceForUnit: "DAY",
          hostelId,
        });
      }
      await refresh?.({ columnRefresh: false, isLoading: false });

      closeModal();
    } else if (response.status === "fail") {
      showErrorMessages({ data: response, navigate });
    } else {
      showErrorMessages({ data: response, navigate });
    }

    setIsLoading(false);
  };
  
  const handleReset = () => {
    if (masterData) {
      const resetData = {
        bed: masterData.BEDS || masterData.BED || "",
        description: masterData.DESCRIPTION || "",
        isAC: masterData.AC || masterData.IS_AC || "N",
        name: masterData.NAME || "",
        price: masterData.PRICE || "",
        priceFor: masterData.PRICE_FOR || "1",
        priceForUnit: masterData.PRICE_FOR_UNIT || "DAY",
        hostelId,
        id: masterData._ID,
      };
      setFormData(resetData);
    } else {
      setFormData({ ...initialFormState, hostelId });
    }
    setErrors({});
  };
// COOL UPDATES   
  return (
    <Container fluid className="p-0">
      {/* Display a warning if hostelId is missing */}
      {!hostelId && (
        <div className="alert alert-warning mb-3">
          Warning: Hostel ID is missing. Some features may not work correctly.
        </div>
      )}
      
      {/* Display form error if any */}
      {errors.form && (
        <div className="alert alert-danger mb-3">
          {errors.form}
        </div>
      )}
      
      <Card className="shadow-sm">
        <Card.Body className="px-4 py-4">
          <Form onSubmit={handleSubmit}>
            <Row className="mb-4">
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Room Type Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter ..."
                    value={formData.name}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, name: e.target.value }))
                    }
                    isInvalid={!!errors.name}
                    style={{ maxWidth: "300px" }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Number of Beds</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    placeholder="Enter ... "
                    value={formData.bed}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, bed: e.target.value }))
                    }
                    isInvalid={!!errors.bed}
                    style={{ maxWidth: "300px" }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.bed}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>AC Available</Form.Label>
                  <div className="d-flex gap-3" style={{ maxWidth: "300px" }}>
                    <Form.Check
                      type="radio"
                      label="Yes"
                      name="isAC"
                      checked={formData.isAC === "Y"}
                      onChange={() =>
                        setFormData((prev) => ({ ...prev, isAC: "Y" }))
                      }
                    />
                    <Form.Check
                      type="radio"
                      label="No"
                      name="isAC"
                      checked={formData.isAC === "N"}
                      onChange={() =>
                        setFormData((prev) => ({ ...prev, isAC: "N" }))
                      }
                    />
                  </div>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Price (₹)</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    placeholder="Enter price"
                    value={formData.price}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        price: e.target.value,
                      }))
                    }
                    isInvalid={!!errors.price}
                    style={{ maxWidth: "300px" }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.price}
                  </Form.Control.Feedback>
                </Form.Group>

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Price Duration</Form.Label>
                      <Form.Control
                        type="number"
                        min="1"
                        placeholder="Enter duration"
                        value={formData.priceFor}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            priceFor: e.target.value,
                          }))
                        }
                        isInvalid={!!errors.priceFor}
                        style={{ maxWidth: "140px" }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.priceFor}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Duration Unit</Form.Label>
                      <Form.Select
                        value={formData.priceForUnit}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            priceForUnit: e.target.value,
                          }))
                        }
                        style={{ maxWidth: "140px" }}
                      >
                        {PRICE_FOR_UNITS.map((unit) => (
                          <option key={unit.value} value={unit.value}>
                            {unit.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Form.Group className="mb-4">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter room type description"
                value={formData.description}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                isInvalid={!!errors.description}
              />
              <Form.Control.Feedback type="invalid">
                {errors.description}
              </Form.Control.Feedback>
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button
                variant="outline-secondary"
                onClick={handleReset}
                disabled={isLoading}
              >
                Reset
              </Button>
              <Button variant="primary" type="submit" disabled={isLoading}>
                {isLoading
                  ? masterData
                    ? "Updating..."
                    : "Adding..."
                  : masterData
                  ? "Update"
                  : "Submit"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      <Modal show={showModal} backdrop="static" keyboard={false}>
        <Modal.Body className="text-center py-4">
          <h5>{modalConfig.title}</h5>
          <p className="mb-0">{modalConfig.message}</p>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default AddHostelRoomTypeForm;